import classnames from 'classnames';
import { PropsWithChildren, useState } from 'react';

import styles from './InnerRadioButton.module.scss';
import { InnerRadioButtonProps } from './InnerRadioButton.types';

export const InnerRadioButton = ({
  checked,
  onChange,
  disabled,
  focus,
  error,
  tabIndex,
  small,
  vertical,
  children,
}: PropsWithChildren<InnerRadioButtonProps>) => {
  const [active, setActive] = useState(false);

  return (
    <div
      className={classnames(styles.container, {
        [styles.vertical]: vertical,
        [styles.disabled]: disabled,
        [styles.active]: active,
        [styles.focus]: focus,
        [styles.error]: error,
        [styles.checked]: checked,
      })}
      onClick={() => {
        if (disabled) return;
        onChange(!checked);
      }}
      tabIndex={tabIndex ?? (disabled ? undefined : 0)}
      onKeyDown={event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          setActive(true);
        }
      }}
      onKeyUp={event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          setActive(false);
          onChange(!checked);
        }
      }}
    >
      <div className={classnames(styles.radioContainer)}>
        <div className={classnames(styles.radioButton)} />
      </div>
      <div className={classnames(styles.label, { [styles.small]: small })}>{children}</div>
    </div>
  );
};
